import { z } from "zod";
export const localeSchema = z.enum(["it", "en"]);
//# sourceMappingURL=locale.js.map